import React from "react"
import accessibleSvg from "src/utils/accessibleSvg"

export default accessibleSvg(({ children, ...props }) => (
  <svg
    fill="currentColor"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
    <path
      id="Team"
      fillRule="evenodd"
      d="M50,100c49.614,0,50-22.386,50-50S99.614,0,50,0,0,22.386,0,50,0.386,100,50,100ZM80.99,69H77.255a3,3,0,0,1-2.5-1.336L72.981,65H55.026l-1.777,2.664A3,3,0,0,1,50.752,69H47.016a1,1,0,0,1-.833-1.554l4.737-7.11A3,3,0,0,1,53.417,59H74.59a3.182,3.182,0,0,1,2.5,1.336l4.737,7.11A1,1,0,0,1,80.99,69ZM64.007,55c-7.286,0-12-4.711-12-12s4.709-12,12-12,12,4.711,12,12S71.293,55,64.007,55Zm0-18c-3.98,0-6,2.019-6,6s2.018,6,6,6,6-2.019,6-6S67.987,37,64.007,37ZM36.018,55c-7.286,0-12-4.711-12-12s4.709-12,12-12,12,4.711,12,12S43.3,55,36.018,55Zm0-18c-3.98,0-6,2.019-6,6s2.018,6,6,6,6-2.019,6-6S40,37,36.018,37Zm9.788,23.787-1.918,2.878A3,3,0,0,1,41.394,65H27.037L25.26,67.664A3,3,0,0,1,22.763,69H19.027a1,1,0,0,1-.832-1.554l4.737-7.111A3,3,0,0,1,25.427,59H44.849A1.15,1.15,0,0,1,45.806,60.787Z"
    />
  </svg>
))
